import { Artifact, ArtifactTheme } from "../../models/client";

export function allAvailableArtifacts(
  artifactTheme: ArtifactTheme
): Artifact[] {
  const sliderArtifacts = artifactTheme.artifactGroups.reduce(
    (artifacts, group) => {
      return [...artifacts, ...group.artifacts];
    },
    [] as Artifact[]
  );

  const allArtifacts = [
    ...sliderArtifacts,
    ...artifactTheme.otherObjects,
    artifactTheme.heroArtifact,
  ];
  return allArtifacts;
}

// export function threeSixtyImageWithInteraction(
//   images: ThreeSixtyImage[],
//   interactions: Interaction[]
// ): ThreeSixtyInteractionImage[] {
//   return images.map((image) => {
//     let interaction = null;
//     if (image.InteractionConfig) {
//       const interactionConfig = image.InteractionConfig;
//       interaction =
//         interactions.find(
//           (interaction) => interaction.Id === interactionConfig.InteractionId
//         ) || null;
//     }
//     return {
//       image: image.Image,
//       interaction,
//       interactionConfig: image.InteractionConfig || null,
//     };
//   });
// }

// function artifactsReducer(artifacts: InteractiveObject[], current)
